module.exports = __webpack_public_path__ + "img/2-s.da675fc7.svg";